// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c40e16a5","732":"350c6dbe","977":"59517781"}[chunkId] + ".chunk.js";
};